export default "__VITE_ASSET__CzNZbRNn__"